import { render, staticRenderFns } from "./p-resource.vue?vue&type=template&id=f4c2fd44&scoped=true&"
import script from "./p-resource.vue?vue&type=script&lang=js&"
export * from "./p-resource.vue?vue&type=script&lang=js&"
import style0 from "./p-resource.vue?vue&type=style&index=0&id=f4c2fd44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c2fd44",
  null
  
)

export default component.exports